<div class="menu-card" tabindex="0" role="button">
  <img [src]="image" [alt]="title" class="card-image" />
  <h2 class="card-title">{{ title }}</h2>
</div>